"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CACHE_KEY = void 0;
exports.getEnvironmentTenantsAndLanguages = getEnvironmentTenantsAndLanguages;
var _cache = require("./internals/cache");
var _fetchConfiguration = require("./internals/fetchConfiguration");
var _loadConfiguration = require("./internals/loadConfiguration");
var _types = require("./types");
var _createConfigurationUrl = require("./utils/createConfigurationUrl");
const CACHE_KEY = exports.CACHE_KEY = 'ENVIRONMENT_TENANTS';
async function getEnvironmentTenantsAndLanguages(environment, options) {
  const configuration = await (0, _loadConfiguration.loadConfiguration)((0, _cache.createCacheKey)(CACHE_KEY, environment), async () => (0, _fetchConfiguration.fetchConfiguration)((0, _createConfigurationUrl.createConfigurationUrl)(_types.ConfigurationType.Hierarchy, environment, 'tenants'), options?.configurationManagerOptions), {
    withoutCache: options?.withoutCache ?? false
  });
  const tenantsAndLanguages = Object.entries(configuration).map(([key, value]) => ({
    tenant: key,
    languages: value?.Languages
  })).sort((a, b) => a.tenant.localeCompare(b.tenant));
  return tenantsAndLanguages;
}
//# sourceMappingURL=getEnvironmentTenantsAndLanguages.js.map